import { useState } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import { deleteUser } from "../../../api/UserAPI";
import { notifications } from "@mantine/notifications";
import {
  ActionIcon,
  Button,
  Group,
  Modal,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { IconTrashX, IconUserX } from "@tabler/icons-react";
import BackButton from "../../../components/View/BackButton";

const DeleteAccount = ({ profile, onSuccess, isOther, inTable }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [canDelete, setCanDelete] = useState(isOther ? false : true);

  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);
    deleteUser(profile.id, data.current_password)
      .then((res) => {
        if (res.data.state) {
          notifications.show({
            message: lang.profile.delete.success_text,
            color: "green.8",
          });
          handleClose();
          if (onSuccess) onSuccess();
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {isOther ? (
        <Tooltip label={lang.profile.delete.button_label}>
          <Button
            color="black"
            variant="light"
            onClick={handleOpen}
            loading={loading}
            disabled={!profile}
            px={10}
            w={"100%"}
          >
            <IconUserX size={20} />
          </Button>
        </Tooltip>
      ) : inTable ? (
        <Tooltip label={lang.profile.delete.button_label}>
          <ActionIcon color="red" variant="subtle" onClick={handleOpen}>
            <IconUserX size={18} />
          </ActionIcon>
        </Tooltip>
      ) : (
        <Button
          color="black"
          variant="light"
          onClick={handleOpen}
          leftSection={<IconUserX size={20} />}
          size="md"
        >
          {lang.profile.delete.button_label}
        </Button>
      )}

      <Modal
        opened={opened}
        onClose={handleClose}
        centered
        title={
          <Text>
            {lang.profile.delete.dialog_title}{" "}
            {isOther ? (
              <b>
                {profile?.first_name} {profile?.last_name} #{profile?.id}
              </b>
            ) : (
              ""
            )}
          </Text>
        }
        styles={{
          content: {
            boxShadow: "red 0 0 6px",
            border: "1px solid #a00",
          },
          title: {
            maxWidth: "92%",
          },
        }}
        size={"md"}
      >
        <Stack component={"form"} onSubmit={handleSubmit}>
          <Text>{lang.profile.delete.dialog_text}</Text>
          {isOther ? (
            <TextInput
              label={lang.profile.delete.email}
              placeholder={lang.profile.delete.email_placeholder}
              onChange={(e) => {
                if (e.target.value === profile.email) setCanDelete(true);
                else setCanDelete(false);
              }}
              fullWidth
              autoFocus
              required
              size="md"
            />
          ) : (
            <PasswordInput
              label={lang.profile.actual_password}
              name="current_password"
              size="md"
              required
            />
          )}

          <Group justify="end" mt={"md"}>
            <BackButton onClick={handleClose} />
            <Button
              type="submit"
              loading={loading}
              disabled={!canDelete}
              color="black"
              leftSection={<IconTrashX size={18} />}
            >
              {lang.profile.delete.submit_button}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default DeleteAccount;
